module.exports = __webpack_public_path__ + "static/img/p10.f375fc32.png";